import { render, staticRenderFns } from "./NewTimeBasedSaleModal.vue?vue&type=template&id=70c7efc6&"
import script from "./NewTimeBasedSaleModal.vue?vue&type=script&lang=js&"
export * from "./NewTimeBasedSaleModal.vue?vue&type=script&lang=js&"
import style0 from "./NewTimeBasedSaleModal.vue?vue&type=style&index=0&id=70c7efc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports